module.exports = __webpack_public_path__ + "img/image87.e6168a67.png";